import { GDPRConfig } from '@ecg-marktplaats/gdpr-consent-string';
import postUserConsent from '../api/postUserConsent';
import logGAEvent from '../helpers/logGAEvent';
import removeConsentBanner from '../helpers/removeConsentBanner';

/**
 * This function handles all the logic for when a user has
 * consented to all purposes.
 *
 * @param gdprConsentString - this is the instantiated GdprConsentString class
 *  from `@ecg-marktplaats/gdpr-consent-string`
 * @param eventAction - this is the event action to log to Google Analytics.
 *  It's `EVENT_ACTION.EXPLICIT_CONSENT_GIVEN`
 */
const acceptedAllConsent = (gdprConsentString, eventAction) => async () => {
  /**
   * Accepts all user consent, saves the TCString to cookies
   * then returns the TCString
   */
  gdprConsentString.acceptAllUserConsent();

  if (GDPRConfig.userLoggedIn) {
    /**
     * Post the TCString to the back end for record keeping
     */
    await postUserConsent(gdprConsentString);
  }

  /**
   * Log explicit consent to Google Analytics
   */
  logGAEvent(eventAction);

  /**
   * Remove the consent banner from the DOM
   */
  removeConsentBanner();
};

export default acceptedAllConsent;
